import { api } from '@/lib/api/client';
import type { GetPaymentsParams, GetRefundRequestsParams, Payment, RefundRequest } from '@shared/types/entities';

import { type PaginatedResponse, buildQuery } from './types';

export async function getPaymentsApi(params?: GetPaymentsParams): Promise<PaginatedResponse<Payment>> {
  return api.get(`/payments${buildQuery(params as Record<string, unknown>)}`);
}

export async function getPaymentApi(id: number): Promise<Payment> {
  return api.get(`/payments/${id}`);
}

/** Récupère tous les paiements d'une organisation en paginant automatiquement (limit max = 100). */
export async function fetchAllPaymentsForOrg(organizationId: number): Promise<Payment[]> {
  const limit = 100;
  let page = 1;
  const all: Payment[] = [];
  while (true) {
    const res = await getPaymentsApi({ organizationId, limit, page });
    all.push(...res.data);
    if (page >= res.meta.totalPages) break;
    page++;
  }
  return all;
}

// ─── RefundRequest workflow admin (Sprint C-bis) ───────────────

export interface RefundRequestsListMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  pendingCount: number;
}

export async function listRefundRequestsApi(
  params?: GetRefundRequestsParams,
): Promise<{ data: RefundRequest[]; meta: RefundRequestsListMeta }> {
  return api.get(`/payments/refund-requests${buildQuery(params as Record<string, unknown>)}`);
}

export async function approveRefundRequestApi(
  id: number,
  body: { decisionNote?: string } = {},
): Promise<RefundRequest> {
  return api.post(`/payments/refund-requests/${id}/approve`, body);
}

export async function rejectRefundRequestApi(id: number, body: { decisionNote: string }): Promise<RefundRequest> {
  return api.post(`/payments/refund-requests/${id}/reject`, body);
}

export async function refundPaymentApi(id: number): Promise<Payment> {
  return api.post(`/payments/${id}/refund`, {});
}

/**
 * D3 (décision 2026-05-22) : création explicite d'une RefundRequest par l'organisateur
 * depuis la page Inscriptions. Le backend (payments.service.requestRefund) crée la
 * RefundRequest + notifie tous les SUPER_ADMIN (in-app + email SMTP).
 */
export async function requestRefundApi(paymentId: number, body: { reason: string }): Promise<RefundRequest> {
  return api.post(`/payments/${paymentId}/request-refund`, body);
}
